import { CrudService, httpClient, type HttpClient } from '../core'
import { accountsEndpoints } from './accounts.endpoints'
import {
  accountPageSchema,
  accountSchema,
  createdAccountSchema,
  type AccountCreateBody,
  type AccountDto,
  type AccountFilters,
  type AccountUpdateBody,
  type CreatedAccountDto,
} from './accounts.schemas'

/** Creating an account answers with the account AND its first user, so `create` returns `CreatedAccountDto`. */
export class AccountsService extends CrudService<AccountDto, AccountCreateBody, AccountUpdateBody, AccountFilters, CreatedAccountDto> {
  constructor(http: HttpClient = httpClient) {
    super(http, accountsEndpoints, { item: accountSchema, page: accountPageSchema, created: createdAccountSchema })
  }
}

export const accountsService = new AccountsService()
